<template>
    <div class="page white_bg">

        <header class="pageHeader detailPageHeader white_bg bottomBorder101010" style="line-height: 46px;">
            <div class="flexLayout paddingH16">
                <div style="width: 16%">
                    <span class="icon leftAngleBracketIcon floatL" style="margin-top: 12px;" @click="back();"></span>
                </div>
                <div class="flexItem alignCenter font18r primaryTextColor bold hiddenOverflow"
                     style="height: 46px; ">
                    {{title}}
                </div>
                <div class="font14r alignRight" style="width: 16%"></div>
            </div>
        </header>

        <div class="body bgEEE">

            <div class="bgWhite" style="height: 58px;">
                <div class="paddingH12">
                    <div class="font12r" style="line-height: 30px;">
                        <span class="green">信息登记</span>
                        <span class="grey floatR">交易完成</span>
                    </div>
                    <div class="paddingH16" style="height: 15px;">
                        <div class="relativePosition">
                            <span class="point startPoint absolutePosition" style="left: 0; z-index: 2"></span>
                            <span class="point endPoint absolutePosition" style="right:0;  z-index: 2"></span>
                            <div class="line absolutePosition" style="width: 100%; height: 1px; line-height: 1px; background: #0FC060;
                                    top: 7px;"></div>
                        </div>
                    </div>
                    <div style="height: 10px;"></div>
                </div>
            </div>

            <form action="javascript:;">
                <div class="generalPagePaddingH bgWhite">

                    <div class="formRow">
                        <div class="columnName">购买产品名称</div>
                        <div class="columnValue relative" style="padding-right:20px;">
                            {{ dataItem ? dataItem.productName : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">交易单号</div>
                        <div class="columnValue color888">
                            {{ dataItem ? dataItem.orderNo : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">交易账号</div>
                        <div class="columnValue color888">
                            {{ dataItem ? dataItem.orderAccount : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">支付时间</div>
                        <div class="columnValue alignR color888">
                            {{ dataItem ? formatDateTime(dataItem.payTime)  : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">支付方式</div>
                        <div class="columnValue alignR">
                            {{ dataItem && paymentTypeEnum ? paymentTypeEnum.getTitleByCode(dataItem.payWay) || '未知' : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">支付金额</div>
                        <div class="columnValue alignR color888">
                            {{ dataItem ? dataItem.payAmount : '' }} 元
                        </div>
                    </div>

                </div>

                <div style="height: 17px;"></div>

                <div class="generalPagePaddingH bgWhite">

                    <div class="formRow">
                        <div class="columnName">工种</div>
                        <div class="columnValue alignR">
                            {{ dataItem && workTypeEnum ? workTypeEnum.getTitleByCode(dataItem.profession) || '未知' : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">出证单位</div>
                        <div class="columnValue alignR color888">
                            {{ dataItem ? dataItem.unitOfCertificate : '' }}
                        </div>
                    </div>

                </div>
                <div style="height: 17px;"></div>

                <div class="generalPagePaddingH bgWhite">

                    <div class="formRow">
                        <div class="columnName">姓名</div>
                        <div class="columnValue">
                            {{ dataItem ? dataItem.name : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">邀请码</div>
                        <div class="columnValue color888">
                            {{ dataItem ? dataItem.userCode : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">手机号</div>
                        <div class="columnValue color888 floatR">
                            {{ dataItem ? dataItem.phone : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">微信号</div>
                        <div class="columnValue color888">
                            {{ dataItem ? dataItem.wxNo : '' }}
                        </div>
                    </div>

                </div>
                <div style="height: 17px;"></div>

                <div class="generalPagePaddingH bgWhite">

                    <div class="formRow">
                        <div class="columnName">性别</div>
                        <div class="columnValue">
                            {{ dataItem && sexEnum ? sexEnum.getTitleByCode(dataItem.sex) || '未知' : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">生日</div>
                        <div class="columnValue color888">
                            {{ dataItem ? formatDate(dataItem.birthday) : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">学历</div>
                        <div class="columnValue color888 floatR">
                            {{ dataItem && userEducationEnum ? userEducationEnum.getTitleByCode(dataItem.education) || '未知' : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">地区</div>
                        <div class="columnValue color888">
                            {{ dataItem ? dataItem.region : '' }}
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">详细地址</div>
                        <div class="columnValue color888">
                            {{ dataItem ? dataItem.address : '' }}
                        </div>
                    </div>

                </div>
                <div style="height: 17px;"></div>


                <div class="generalPagePaddingH bgWhite">

                    <div class="formRow">
                        <div class="columnName">身份证号</div>
                        <div class="columnValue color888">
                            {{ dataItem ? dataItem.idCard : '' }}
                        </div>
                    </div>

                    <div class="">
                        <div class="marginB12">上传身份证照片</div>
                        <div v-if="dataItem">
                            <img v-if="dataItem.idCard" class="limit_max_width" :src="dataItem.idCardImg1" />
                        </div>
                        <div v-if="dataItem">
                            <img v-if="dataItem.idCard" class="limit_max_width" :src="dataItem.idCardImg2" />
                        </div>
                    </div>

                    <div style="color: #B7B6B5;">注：身份证认证是基于用户提现时需要进行实名认证，请您保证您填写的信息真实有效。</div>

                    <div class="marginT24">
                        <div class="">上传证件照（2寸/蓝底）</div>

                        <div v-if="dataItem">
                            <img v-if="dataItem.idPhoto" class="limit_max_width" :src="dataItem.idPhoto" />
                        </div>
                    </div>

                </div>

                <div class="marginT12 paddingH24 paddingV20 bgWhite">
                    <div class="remarkArea font14r paddingH20 paddingV30 marginB8 roundBorder4 alignC"
                         v-if="dataItem && dataItem.status == auditStatusEnum.AUDIT_FAILURE.code">
                        {{ dataItem.remark || '审核失败，没有任何备注信息' }}
                    </div>
                    <button class="block w100p auditButton roundBorder4 font14r marginT4"
                            v-if="dataItem && dataItem.status == auditStatusEnum.UNREVIEWED.code">
                        审核中，耐心等待~
                    </button>
                    <button class="block w100p alterButton roundBorder4 font14r marginT4"
                            v-if="dataItem && dataItem.status == auditStatusEnum.AUDIT_FAILURE.code"
                            @click="edit()">
                        修改后提交
                    </button>

                </div>
            </form>

        </div><!-- end .body -->

    </div>
</template>

<script>
// parts and modules
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// data
import auditStatusEnum from "@data/auditStatusEnum";

// API and utils
import dictApi from "@comp/dict/dictApi";
import consoleApi from "@/components/platformApi/consoleApi";
import appHelper from "@util/appHelper";

const config = {
    name : 'registerInformationDetail',
    title : '购买信息登记',
    description : '',
    apiConfig : {
        get : {
            url : 'portal/information/get',
            dataColumnMapping : {
                // userName : 'name'
            }
        }

    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            enableDataItem : true,
            autoLoadDataItem : true,
            auditStatusEnum,
            paymentTypeEnum : null,
            workTypeEnum : null,
            sexEnum : null,
            userEducationEnum : null,
        }
    },
    methods : {
        edit() {
            appHelper.goToPage('registerInformationEdit', {
                id : this.dataItem.id
            });
        }
    },
    mounted() {
        dictApi.getEnumByModule('paymentType', (e) => {
            this.paymentTypeEnum = e;
        });
        dictApi.getEnumByModule('workType', (e) => {
            this.workTypeEnum = e;
        });
        dictApi.getEnumByModule('sex', (e) => {
            this.sexEnum = e;
        });
        dictApi.getEnumByModule('userEducation', (e) => {
            this.userEducationEnum = e;
        });

    }
}
</script>

<style lang="scss" scoped>
.green {
    color: #0FC060
}
.color888 {
    color: #888;
}
.point {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 7px;
    line-height: 15px;
    overflow: hidden;
}
.startPoint {
    background: #0FC060;
}
.endPoint {
    background: #888;
}
.formRow {
    display: flex;
    padding: 10px 0;
    //height: 30px;
    line-height: 30px;
    .columnName {
        color: #5B616C;
        width: 72px;
    }
    .columnValue {
        flex: 1;
        .inputbox {
            display: block;
            width: 100%;
            font-size: 16px;
            height: 27px;
            line-height: 27px;
            border: none;
            background: transparent;
            color: hsla(0, 0%, 20%, 1);
            outline: none;
        }
        .inputbox::placeholder,
        .inputbox::-webkit-input-placeholder,
        .inputbox::-moz-placeholder,
        .inputbox::-ms-input-placeholder {
            color: hsla(220, 27%, 78%, 1);
        }
    }
}
.remarkArea {
    border: solid 1px #E68C20;
    color: #E68C20;
}
.auditButton {
    background: #777777;
    color: white;
    height: 40px;
    line-height: 40px;
    padding: 0;
    border: none 0;
}
.alterButton {
    background: #E68C20;
    color: white;
    height: 40px;
    line-height: 40px;
    padding: 0;
    border: none 0;
}
</style>
